(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-slideshow')) return;

    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.allSlides = Array.from(this.querySelectorAll('[data-slide]'));
        this.allDots = Array.from(this.querySelectorAll('[data-goto]'));
        this.counter = this.querySelector('[data-counter]');
        this.nav = this.querySelector('.hero-slides__nav');
        this.toggleButton = this.querySelector('[data-toggle]');
        this.slides = [];
        this.dots = [];
        this.index = 0;
        this.interval = (parseFloat(this.dataset.interval) || 5) * 1000;
        this.userPaused = false;
        this.hovering = false;
        this.focused = false;
        this.offscreen = false;
        this.timer = null;
        this.timerStart = 0;
        this.timerDelay = 0;
        this.remaining = this.interval;
        this.autoplay =
          this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.deviceQuery = window.matchMedia('(max-width: 749px)');
        this.refreshSlides(false);

        if (!this.allSlides.length) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.allDots.forEach((dot) => {
          dot.addEventListener('click', () => this.go(Number(dot.dataset.goto), true));
        });
        this.toggleButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updatePaused();
        });

        this.addEventListener('mouseenter', () => {
          this.hovering = true;
          this.updatePaused();
        });
        this.addEventListener('mouseleave', () => {
          this.hovering = false;
          this.updatePaused();
        });
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.updatePaused();
        });
        this.addEventListener('focusout', (e) => {
          this.focused = this.contains(e.relatedTarget);
          this.updatePaused();
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });

        let startX = 0;
        let startY = 0;
        this.addEventListener(
          'touchstart',
          (e) => {
            startX = e.changedTouches[0].clientX;
            startY = e.changedTouches[0].clientY;
          },
          { passive: true }
        );
        this.addEventListener(
          'touchend',
          (e) => {
            const dx = e.changedTouches[0].clientX - startX;
            const dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
              this.go(this.index + (dx < 0 ? 1 : -1), true);
            }
          },
          { passive: true }
        );

        this.onDeviceChange = () => this.refreshSlides(true);
        if (this.deviceQuery.addEventListener) {
          this.deviceQuery.addEventListener('change', this.onDeviceChange);
        } else {
          this.deviceQuery.addListener(this.onDeviceChange);
        }

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.offscreen = !entry.isIntersecting;
            this.updatePaused();
          },
          { threshold: 0.25 }
        );
        // <hero-slideshow> uses display: contents; observe its parent instead.
        this.observer.observe(this.parentElement);

        this.onBlockSelect = (e) => {
          const target = this.slides.findIndex((slide) => slide.dataset.blockId === e.detail.blockId);
          if (target > -1) {
            this.userPaused = true;
            this.go(target, false);
            this.updatePaused();
          }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.updatePaused();
      }

      disconnectedCallback() {
        this.stop();
        this.observer?.disconnect();
        if (this.onDeviceChange && this.deviceQuery) {
          if (this.deviceQuery.removeEventListener) {
            this.deviceQuery.removeEventListener('change', this.onDeviceChange);
          } else {
            this.deviceQuery.removeListener(this.onDeviceChange);
          }
        }
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      refreshSlides(preserveCurrent) {
        const activeBlockId = preserveCurrent ? this.slides[this.index]?.dataset.blockId : null;
        const isMobile = this.deviceQuery.matches;
        this.slides = [];
        this.dots = [];
        let activeIndex = -1;
        let visibleIndex = 0;

        // Slides and their navigation controls share the same block order.
        for (let i = 0; i < this.allSlides.length; i++) {
          const slide = this.allSlides[i];
          const dot = this.allDots[i];
          const model = slide.dataset.model || 'all';
          const visible = model === 'all' || (isMobile ? model === 'mobile' : model === 'desktop');

          slide.hidden = !visible;
          slide.inert = true;
          slide.dataset.active = 'false';
          if (dot) {
            dot.hidden = !visible;
            dot.setAttribute('aria-current', 'false');
          }
          if (!visible) continue;

          slide.setAttribute('aria-label', `Slide ${visibleIndex + 1}`);
          this.slides.push(slide);
          if (dot) {
            dot.dataset.goto = String(visibleIndex);
            dot.setAttribute('aria-label', `Go to slide ${visibleIndex + 1}`);
            this.dots.push(dot);
          }
          if (slide.dataset.blockId === activeBlockId) activeIndex = visibleIndex;
          visibleIndex++;
        }

        // Keep a usable hero if no slide has been assigned to the current device.
        if (!this.slides.length && this.allSlides.length) {
          const firstSlide = this.allSlides[0];
          const firstDot = this.allDots[0];
          firstSlide.hidden = false;
          firstSlide.setAttribute('aria-label', 'Slide 1');
          this.slides.push(firstSlide);
          if (firstDot) {
            firstDot.hidden = false;
            firstDot.dataset.goto = '0';
            firstDot.setAttribute('aria-label', 'Go to slide 1');
            this.dots.push(firstDot);
          }
        }

        this.index = activeIndex >= 0 ? activeIndex : 0;
        const activeSlide = this.slides[this.index];
        const activeDot = this.dots[this.index];
        if (activeSlide) {
          activeSlide.dataset.active = 'true';
          activeSlide.inert = false;
        }
        activeDot?.setAttribute('aria-current', 'true');

        if (this.counter)
          this.counter.textContent = `${this.slides.length ? this.index + 1 : 0} / ${this.slides.length}`;
        if (this.nav) this.nav.hidden = this.slides.length < 2;
        this.dataset.autoplay = String(this.autoplay && this.slides.length > 1);
        this.stop();
        this.start();
      }

      go(next, restart) {
        const total = this.slides.length;
        if (total < 2) return;
        next = (next + total) % total;
        if (next === this.index) return;

        const previousSlide = this.slides[this.index];
        const nextSlide = this.slides[next];
        previousSlide.dataset.active = 'false';
        previousSlide.inert = true;
        nextSlide.dataset.active = 'true';
        nextSlide.inert = false;
        this.dots[this.index]?.setAttribute('aria-current', 'false');
        this.dots[next]?.setAttribute('aria-current', 'true');
        this.dots[next]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        if (this.counter) this.counter.textContent = `${next + 1} / ${total}`;
        this.index = next;
        if (restart || this.autoplay) this.start();
      }

      // Begin a fresh interval for the current slide (new slide, manual nav, refresh).
      start() {
        this.stop();
        this.remaining = this.interval;
        this.resume();
      }

      // Continue the current interval with whatever time is left (no-op if already running).
      resume() {
        if (this.timer !== null) return;
        if (!this.autoplay || this.slides.length < 2 || this.isPaused()) return;
        this.timerStart = performance.now();
        this.timerDelay = this.remaining;
        this.timer = setTimeout(() => {
          this.timer = null;
          this.go(this.index + 1, false);
        }, this.remaining);
      }

      // Freeze the interval, remembering how much time is left. Mirrors the
      // CSS progress bar, which keeps its progress via animation-play-state.
      pause() {
        if (this.timer === null) return;
        const elapsed = performance.now() - this.timerStart;
        this.remaining = Math.max(0, this.timerDelay - elapsed);
        this.stop();
      }

      stop() {
        clearTimeout(this.timer);
        this.timer = null;
      }

      isPaused() {
        return this.userPaused || this.offscreen;
      }

      updatePaused() {
        const paused = this.isPaused();
        this.dataset.paused = String(paused);
        this.dataset.autoplay = String(this.autoplay && this.slides.length > 1);
        this.toggleButton?.setAttribute('aria-label', this.userPaused ? 'Play slideshow' : 'Pause slideshow');
        if (paused) {
          this.pause();
        } else {
          this.resume();
        }
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
